import RTMClient from "../utils/agochat";
import {isnull, localGet, localSave, Toast, Uint8ArrayToString} from "../utils/tools";
import global from "../config/global";

export default {
  getClient(useDefault = true) {
    var rtm = global.application.$root.rtm
    if (useDefault) {
      if (rtm == null) {
        rtm = new RTMClient();
        global.application.$root.rtm = rtm
      }
    }
    return rtm;
  }
}



// WEBPACK FOOTER //
// ./src/rtm/RtmClientManager.js